import { Component } from 'react';
import PropTypes from 'prop-types';
import Spinner from '~/js/components/general/Spinner';
import EventItem from '~/js/components/liv-plus/EventItem';
import categoriesData from '~/js/components/liv-plus/data/categories';
/* eslint-disable */

class MainView extends Component {
    constructor(props) {
        super(props);

        this.footerRef = React.createRef();

        props.setDefaultSection();
    }

    componentDidMount() {
        this.props.initialTopScroll();
    }

    categoryBlock({ type, description, img, logo }) {
        const { events } = this.props;
        const classes = ['category-row', 'row', 'end-xs'];

        if (!events.length) {
            classes.push('no-events');
        }

        return (
            <div className={classes.join(' ')}>
                <div className="hexagon" />
                <div className={`xs-12 xl-10 category-block ${type}`}>
                    <svg viewBox="0 0 260 300" width="260" height="300">
                        <defs>
                            <clipPath
                                id="categoryClipPath"
                                clipPathUnits="userSpaceOnUse"
                            >
                                <polygon points="130 0,260 75,260 225,130 300,0 225,0 75" />
                            </clipPath>
                        </defs>

                        <image
                            width="100%"
                            height="100%"
                            preserveAspectRatio="xMinYMin slice"
                            xlinkHref={img}
                            clipPath="url(#categoryClipPath)"
                        />
                    </svg>

                    <div className="category-content">
                        <div className="category-logo">
                            <img src={logo} alt={type} />
                        </div>
                        <p>{description}</p>
                    </div>
                </div>
            </div>
        );
    }

    scrollToRef = (ref, offSet) => () => {
        if (ref) {
            $('body, html').animate(
                {
                    scrollTop: ref.current.offsetTop + offSet
                },
                500
            );
        }
    };

    render() {
        const {
            events,
            tabChecked,
            loading,
            learMoreHandler,
            tabHandler
        } = this.props;
        const { cdn_url: cdnURL } = window.beaches_app.global;

        let eventsView = <Spinner />;

        if (!loading) {
            if (events.length) {
                eventsView = events.map((event, index) => (
                    <EventItem
                        key={index}
                        eventId={event.eventId}
                        type={event.groupName.toLowerCase()}
                        eventName={event.eventName}
                        eventDate={event.livPlusEventDateWithoutHtml}
                        eventRstCode={event.rstCode}
                        eventResorts={event.rstCodes}
                        customRstInfo={event.customRstInfo}
                        resortInfoPlaceholder={event.resortInfo}
                        groupName={event.groupName}
                        images={event.mainImages}
                        description={event.descriptionWithoutHtml}
                        externalLink={event.landingPageUrl}
                        onLearMore={() => learMoreHandler(event)}
                    />
                ));
            } else if (tabChecked) {
                eventsView = (
                    <div className={`coming-soon ${tabChecked.type}`}>
                        <span>
                            Upcoming {tabChecked.caption} Events{' '}
                            <strong>Coming Soon</strong>
                        </span>
                    </div>
                );
            } else {
                eventsView = (
                    <div className="no-results">
                        Currently, there are no events
                    </div>
                );
            }
        }

        return (
            <div className="main-view">
                <section className="black-bg">
                    <article className="main-article xs-12">
                        <h1 className="title-10">special events</h1>
                        <hr class="divider-line"/>
                        <small>Seek More In a Vacation than just a destination</small>
                        <div className="main-article-inner">
                            <p>
                            Now, you can enjoy Sandals incredible inclusions, plus indulge in special events and experiences centered around music, culture, sports, culinary, voluntourism, and social interest.
                            </p>
                        </div>
                    </article>
                </section>
                <div className="container">
                    {eventsView}
                </div>
            </div>
        );
    }
}

MainView.propTypes = {
    events: PropTypes.array,
    tabChecked: PropTypes.object,
    learMoreHandler: PropTypes.func,
    tabHandler: PropTypes.func,
    initialTopScroll: PropTypes.func,
    setDefaultSection: PropTypes.func
};

MainView.defaultProps = {
    events: [],
    learMoreHandler: () => {},
    tabHandler: () => {},
    initialTopScroll: () => {},
    setDefaultSection: () => {}
};

export default MainView;
